module.exports = __webpack_public_path__ + "img/cover-johan.9ee529f6.png";